module.exports = __webpack_public_path__ + "img/vertical_2_1_9005.b840aa6a.png";